import { Component, OnInit } from '@angular/core';

import * as models from '../../../models';
import * as services from '../../../services';
import * as viewmodels from 'app/viewmodels';
import { v4 as uuidv4 } from 'uuid';
import { ExportToCsv, Options } from 'export-to-csv';
import { MatDialog } from '@angular/material/dialog';
import { StrainUploadDialogComponent } from 'app/dialogs';

@Component({
    selector: 'app-strain-setup',
    templateUrl: './strain-setup.component.html',
    styleUrls: ['./strain-setup.component.scss'],
    standalone: false
})
export class StrainSetupComponent implements OnInit {
  saving: boolean = false;
  searchText: string = '';
  newStrainName: string = '';
  editingStrainId: string = null;
  editingStrainName: string = '';
  
  // strainsValue: Array<models.Strain>;
  // @Input()
  // get strains() {
  //   return this.strainsValue;
  // }
  // @Output() strainsChange = new EventEmitter();
  // set strains(val) {
  //   if(val == null){
  //     val = [];
  //   }
  //   this.strainsValue = val;
  //   this.strainsChange.emit(this.strainsValue);
  // }
  strains: Array<models.Strain> = [];
  initialStrains: Array<models.Strain> = [];
  
  csvExporter: ExportToCsv;

  get dirty() {
    let jStrains = JSON.stringify(this.strains);
    let iStrains = JSON.stringify(this.initialStrains);

    return jStrains != iStrains;
  }

  get filteredStrains(): Array<models.Strain> {
    let search = this.searchText.trim().toLocaleLowerCase();
    let strains = this.strains || [];

    return strains
      .filter(strain => !search || strain.name?.toLocaleLowerCase().includes(search))
      .slice()
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  }

  constructor(
    private strainService: services.StrainService
    , private helperService: services.HelperService
    , private notifierService: services.NotifierService
    , private leaflogixService: services.LeaflogixService
    , private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.getLeaflogix();
    this.getStrains();
  }

  async getStrains() {
    this.strains = await this.strainService.getAll();
    this.initialStrains = this.helperService.deepCopy(this.strains);
    this.cancelEdit();
  }

  add(): void {
    let name = this.newStrainName.trim();
    if (!name) return;

    if (this.hasDuplicateName(name)) {
      this.notifierService.error('Cannot create a Strain with the same name');
      return;
    }

    this.strains.push({id: uuidv4(), name: name});
    this.newStrainName = '';
  }

  remove(strain: models.Strain): void {
    const index = this.strains.indexOf(strain);

    if (index >= 0) {
      this.strains.splice(index, 1);
    }
  }

  edit(strain: models.Strain): void {
    this.editingStrainId = strain.id;
    this.editingStrainName = strain.name;
  }

  applyEdit(strain: models.Strain): void {
    let name = this.editingStrainName.trim();
    if (!name) return;

    if (this.hasDuplicateName(name, strain.id)) {
      this.notifierService.error('Cannot rename a Strain to an existing name');
      return;
    }

    strain.name = name;
    this.cancelEdit();
  }

  cancelEdit(): void {
    this.editingStrainId = null;
    this.editingStrainName = '';
  }

  private hasDuplicateName(name: string, excludedId?: string): boolean {
    let normalizedName = name.toLocaleLowerCase();
    return this.strains.some(strain =>
      strain.id !== excludedId && strain.name?.trim().toLocaleLowerCase() === normalizedName
    );
  }

  async save() {
    this.saving = true;
    await this.strainService.update(this.strains);
    this.saving = false;
    this.getStrains();
  }

  canSeeLeaflogix: boolean = false;
  getLeaflogix() {
    let company = this.helperService.currentCompany;
    this.canSeeLeaflogix = company?.leaflogix?.active;
  }

  refreshingStrains: boolean = false;
  async refreshStrainsClick() {
    this.notifierService.confirm('Refresh Strains?', 'Are you sure you want to sync Strains?  This will overwrite any existing information you’ve already saved.',
    () => {this.refreshStrains()}, () => {})
  }
  async refreshStrains() {

    this.refreshingStrains = true;
    let retVal = await this.leaflogixService.integrateStrains();
    let response: models.Result<boolean> = retVal.data;

    if(response.success){
      this.notifierService.success('Successfully integrated Strains')
      this.getStrains();
    } else {
      this.notifierService.error('There was an error syncing with Dutchie.  Please check API key.')
    }
    this.refreshingStrains = false;
  }

  export() {
    let options: Options = { 
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true, 
      showTitle: false,
      title: 'Strains Export',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      filename: 'Strains Export',
      //headers: ['Phase', 'Day in Phase', 'Task Description', 'High Priority', "Anytime", "Start Time", "Cloud Attachments", "Notes"]
    };
  
    this.csvExporter = new ExportToCsv(options);

    let strainsToExport: viewmodels.StrainExport[] = []
    this.strains.forEach(strain => {
      let strainExport: viewmodels.StrainExport = new viewmodels.StrainExport({strains: strain.name})
      strainsToExport.push(strainExport);
    });

    this.csvExporter.generateCsv(strainsToExport);
  }

  import() {
    let dialogRef = this.dialog.open(StrainUploadDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      //reload list
      if(result){
        this.getStrains();
      }
      console.log(JSON.stringify(result));
    })
  }
}
